export const DisbursementCommentEnum = {
  C_INAC_BLQ: "Cuenta inactiva o bloqueada", // acción - ReintentarUsuario
  N_CU_INVA: "Numero de cuenta invalido", // acción - ReintentarUsuario
  S_REC_M_INVA: "Solicitud rechazada - Monto inválido", // acción - Anular
  C_BAN_C_D_INC: "Cuenta bancaria con datos incompletos", // acción - ReintentarUsuario
  ERR_ARCH: "Error de archivo", // acción - ReintentarGalilea
  C_N_NO_COINCIDEN: "Cuenta y nit no coinciden", // acción - ReintentarUsuario
  CN_AUTH_PACRE: "Cuenta no autorizada para acreditar", // acción - Anular
  DESISTIO: "Desistió", // acción - Anular
  C_NO_EXI: "Cuenta no existe", // acción - ReintentarUsuario
  TCD_N_VALIDO: "Tipo de cuenta de destino no valido", // acción - ReintentarUsuario
  CI_BANCOLOMBIA: "Caida Bancolombia", // acción - ReintentarGalilea
  FOND_INSUF: "Fondos insuficientes", // acción - ReintentarGalilea
  TDCD_N_VALIDO: "Tipo de cuenta destino no valido", // acción - ReintentarUsuario
  NTG_NUEVO: "no tomo el cero se gira de nuevo", // acción - ReintentarGalilea
  PRUEBAS: "Pruebas", // acción - Anular
  C_ACH_N_EXIS: "Cuenta ACH no existe", // acción - ReintentarUsuario
};

/**
 * Comentarios que generan un FALLO en el desembolso pero NO crean un nuevo desembolso.
 * El usuario debe corregir sus datos (cuenta, tipo de cuenta, etc.) para reintentar.
 */
export const reintentarUsuarioComments = [
  DisbursementCommentEnum.C_INAC_BLQ,
  DisbursementCommentEnum.N_CU_INVA,
  DisbursementCommentEnum.C_BAN_C_D_INC,
  DisbursementCommentEnum.C_NO_EXI,
  DisbursementCommentEnum.C_N_NO_COINCIDEN,
  DisbursementCommentEnum.TCD_N_VALIDO,
  DisbursementCommentEnum.TDCD_N_VALIDO,
  DisbursementCommentEnum.C_ACH_N_EXIS,
];
